import { useCallback } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { atLeast } from "@/lib/roles";

// No deleting data without an admin's approval (Anish, 21 Oct 2026). An admin deletes as before
// (with the page's own confirm, if it has one). Anyone else is asked why, and the delete becomes a
// request an admin approves in Global Admin → Deletion requests.
// ask(what, confirmText) → "" (admin, go ahead), the reason (anyone else), or null (cancelled).
// minRole "manager": small undos (check-in, clock-in, a roster day) managers do themselves (23 Oct 2026).
export function useDeleteAsk(minRole = "admin") {
  const { user, effectiveRole } = useAuth();
  const isAdmin = minRole === "admin" ? atLeast(user?.role, "admin") : atLeast(effectiveRole || user?.role, minRole);
  return useCallback((what, confirmText) => {
    if (isAdmin) return !confirmText || window.confirm(confirmText) ? "" : null;
    const r = window.prompt(`Deleting ${what} needs an admin's approval. Say why it should go (e.g. entered twice):`);
    if (r === null) return null;
    if (!r.trim()) { toast.error("Say why it should be deleted"); return null; }
    return r.trim();
  }, [isAdmin]);  // eslint-disable-line react-hooks/exhaustive-deps
}

// The API answered with a deletion request (already toasted "Sent to an admin for approval").
export const deletionRequested = (res) => !!res?.deletion_requested;
